import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Login from "./pages/Login";
import AdminDashboard from "./pages/admin/Dashboard";
import StudentsPage from "./pages/admin/Students";
import StudentImportPage from "./pages/admin/StudentImport";
import BusesPage from "./pages/admin/Buses";
import OperatorsPage from "./pages/admin/Operators";
import QRCodesPage from "./pages/admin/QRCodes";
import AttendancePage from "./pages/admin/Attendance";
import PaymentsPage from "./pages/admin/Payments";
import PaymentCyclesPage from "./pages/admin/PaymentCycles";
import OperatorBuses from "./pages/operator/SelectBus";
import ScanScreen from "./pages/operator/Scan";

function RootRedirect() {
    const { user, checking } = useAuth();
    if (checking) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-white">
                <div className="w-10 h-10 border-4 border-[#FF3B30] border-t-transparent animate-spin" />
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return <Navigate to={["admin", "superadmin"].includes(user.role) ? "/admin" : "/operator"} replace />;
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Toaster position="top-center" richColors />
                    <Routes>
                        <Route path="/" element={<RootRedirect />} />
                        <Route path="/login" element={<Login />} />

                        {/* Admin */}
                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute role={["admin", "superadmin"]}>
                                    <AdminDashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin/students"
                            element={
                                <ProtectedRoute role={["admin", "superadmin"]}>
                                    <StudentsPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin/students/import"
                            element={
                                <ProtectedRoute role={["admin", "superadmin"]}>
                                    <StudentImportPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin/buses"
                            element={
                                <ProtectedRoute role={["admin", "superadmin"]}>
                                    <BusesPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin/operators"
                            element={
                                <ProtectedRoute role={["admin", "superadmin"]}>
                                    <OperatorsPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin/qrcodes"
                            element={
                                <ProtectedRoute role={["admin", "superadmin"]}>
                                    <QRCodesPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin/attendance"
                            element={
                                <ProtectedRoute role={["admin", "superadmin"]}>
                                    <AttendancePage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin/payments"
                            element={
                                <ProtectedRoute role={["admin", "superadmin"]}>
                                    <PaymentsPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin/cycles"
                            element={
                                <ProtectedRoute role={["admin", "superadmin"]}>
                                    <PaymentCyclesPage />
                                </ProtectedRoute>
                            }
                        />

                        {/* Operator */}
                        <Route
                            path="/operator"
                            element={
                                <ProtectedRoute role="operator">
                                    <OperatorBuses />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/operator/scan"
                            element={
                                <ProtectedRoute role="operator">
                                    <ScanScreen />
                                </ProtectedRoute>
                            }
                        />

                        <Route path="*" element={<RootRedirect />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
